import { defineComponent, onBeforeUnmount, onMounted, watch, ref } from 'vue';
import omit from '../_util/omit';
import initDefaultProps from '../_util/props-util/initDefaultProps';
import { someType, stringType } from '../_util/type';
import Statistic, { statisticProps } from './Statistic';
import { formatCounter } from './utils';
const REFRESH_INTERVAL = 1000 / 30;
function getTime(value) {
    return new Date(value).getTime();
}
export const timerProps = () => {
    return Object.assign(Object.assign({}, statisticProps()), { value: someType([Number, String, Object]), format: String, 
        /** Timer direction (antd ≥ 5.25). */
        type: stringType('countdown'), onFinish: Function, onChange: Function });
};
export default defineComponent({
    compatConfig: { MODE: 3 },
    name: 'AStatisticTimer',
    props: initDefaultProps(timerProps(), {
        format: 'HH:mm:ss',
        type: 'countdown',
    }),
    setup(props, { emit, slots }) {
        const timerId = ref();
        const statistic = ref();
        const isCountdown = () => props.type !== 'countup';
        const clearTimer = () => {
            if (timerId.value) {
                clearInterval(timerId.value);
                timerId.value = undefined;
            }
        };
        const startTimer = () => {
            if (timerId.value)
                return;
            timerId.value = setInterval(() => {
                var _a, _b;
                (_b = (_a = statistic.value) === null || _a === void 0 ? void 0 : _a.$forceUpdate) === null || _b === void 0 ? void 0 : _b.call(_a);
                const now = Date.now();
                const timestamp = getTime(props.value);
                const timeDiff = isCountdown() ? timestamp - now : now - timestamp;
                emit('change', timeDiff);
                if (isCountdown() && timestamp <= now) {
                    clearTimer();
                    emit('finish');
                }
            }, REFRESH_INTERVAL);
        };
        const syncTimer = () => {
            clearTimer();
            const timestamp = getTime(props.value);
            if (isCountdown()) {
                if (timestamp > Date.now()) {
                    startTimer();
                }
            }
            else {
                startTimer();
            }
        };
        const formatTimer = ({ value, config }) => {
            return formatCounter(value, Object.assign(Object.assign({}, config), { format: props.format }), isCountdown());
        };
        const valueRenderHtml = (node) => node;
        onMounted(() => {
            syncTimer();
        });
        watch(() => [props.value, props.type], () => {
            syncTimer();
        });
        onBeforeUnmount(() => {
            clearTimer();
        });
        return () => {
            const value = props.value;
            return (<Statistic ref={statistic} {...Object.assign(Object.assign({}, omit(props, ['onFinish', 'onChange', 'type'])), { value, valueRender: valueRenderHtml, formatter: formatTimer })} v-slots={slots}/>);
        };
    },
});
